module.exports = __webpack_public_path__ + "static/img/up-corner-ramp-8m-x-1m_256.8be3897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-ramp-8m-x-1m_256.png
// module id = IRQT
// module chunks = 0